// Search runs against the project's Notion bot token, so results already respect
// what the bot can see. Titles and URLs are untrusted; render as text and only
// in an href, never as markup.

import { isString } from "../utils/schemaUtils";

export interface NotionSearchItem {
  id: string;
  // "page" or "database".
  type: string;
  title: string;
  url: string;
}

export interface NotionSearchResultsPayload {
  type: "notion_search_results";
  query?: string;
  results: NotionSearchItem[];
}

const isNotionSearchItem = (v: unknown): v is NotionSearchItem => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return isString(r.id) && isString(r.type) && isString(r.title) && isString(r.url);
};

export const parseNotionSearchResultsPayload = (v: unknown): NotionSearchResultsPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "notion_search_results") return null;
  if (r.query !== undefined && !isString(r.query)) return null;
  if (!Array.isArray(r.results) || !r.results.every(isNotionSearchItem)) return null;
  return {
    type: "notion_search_results",
    query: r.query,
    results: r.results,
  };
};
